export default __webpack_public_path__ + "static/media/m_welcome_bg.0d5ba347.png";